/* eslint-disable */
export default {
  install: function (Vue) {
  	Vue.prototype.office = [
    	{'id': 1, 'c_name': '上海办公室', 'e_name': 'Shanghai Office', 'type': 0, 'taxRate': '0.06', 'address': '31F, Harbour Ring Plaza, No.18 Middle XiZang Road,<br>Shanghai, China, 200001', 'c_address': '上海市黄浦区西藏中路18号港陆广场办公楼31层, 200001' },
        {'id': 2, 'c_name': '北京办公室', 'e_name': 'Beijing Office', 'type': 0, 'taxRate': '0.06', 'address': 'Room 2201, Wentley Business Conference Center ,<br>1 West Dawang Road, Chaoyang District, Beijing, China', 'c_address': '中国北京市朝阳区大望西路温特莱商务中心2201室' },
        {'id': 3, 'c_name': '苏州办公室', 'e_name': 'Suzhou Office', 'type': 0, 'taxRate': '0.06', 'address': 'Room 1204, Block B, Suzhou Center, Suzhou, China, 215124', 'c_address': '中国江苏省苏州市姑苏园区苏州中心B座1204室, 215124' },
        {'id': 4, 'c_name': '香港办公室', 'e_name': 'Hong Kong Office', 'type': 1, 'taxRate': '0.00', 'address': 'Room 2202, Honest Building, 911 Leighton Road,<br>Causeway Bay, HongKong', 'c_address': '香港铜锣湾礼顿道9-11号合诚大厦2202室' },
        {'id': 5, 'c_name': '新加坡办公室', 'e_name': 'Singapore Office', 'type': 1, 'taxRate': '0.09', 'address': '3F, No.135 Middle Road. Bylands Building,<br>Singapore 188975', 'c_address': '' }, 
        {'id': 6, 'c_name': '吉隆坡办公室', 'e_name': 'Kuala Lumpur Office', 'type': 1, 'taxRate': '0.08', 'address': '', 'c_address': '' }, 
        {'id': 7, 'c_name': '阿姆斯特丹办公室', 'e_name': 'Amsterdam Office', 'type': 1, 'taxRate': '0.21', 'address': 'Van Boshuizenstraat 12 office 1.25 1083 BA<br>Amsterdam, The Netherlands', 'c_address': '' }, 
        {'id': 8, 'c_name': '孟买办公室', 'e_name': 'Mumbai Office', 'type': 1, 'taxRate': '0.00', 'address': '', 'c_address': '' }, 
        {'id': 9, 'c_name': '文莱办公室', 'e_name': 'Brunei Office', 'type': 1, 'taxRate': '0.00', 'address': '', 'c_address': '' }, 
        {'id': 10, 'c_name': '深圳办公室', 'e_name': 'Shenzhen Office', 'type': 0, 'taxRate': '0.06', 'address': '', 'c_address': '' }, 
        {'id': 11, 'c_name': '台北办公室', 'e_name': 'Taipei Office', 'type': 1, 'taxRate': '0.00', 'address': 'No. 206, Sec. 1, Keelung Rd., Xinyi Dist.,<br>Taipei City 110058', 'c_address': '台北市信义区基隆路段206号17楼-110058' }, 
        {'id': 12, 'c_name': '首尔办公室', 'e_name': 'Seoul Office', 'type': 1, 'taxRate': '0.00', 'address': '', 'c_address': '' }, 
        {'id': 12, 'c_name': '胡志明市办公室', 'e_name': 'Ho Chi Minh City Office', 'type': 1, 'taxRate': '0.00', 'address': '', 'c_address': '' },
        {'id': 13, 'c_name': '武汉办公室', 'e_name': 'Wuhan Office', 'type': 0, 'taxRate': '0.06', 'address': '', 'c_address': '湖北省武汉市东湖新技术开发区高新人道999号未来科技城B区1503A' },
        {'id': 14, 'c_name': '东京办公室', 'e_name': 'Tokyo Office', 'type': 0, 'taxRate': '0.05', 'address': 'Metropolitan Building 14-136 Nishiikebukuro, Toshima–ku,<br>Tokyo, Japan', 'c_address': '' },
        {'id': 15, 'c_name': '客户办公室', 'e_name': 'Client Office', 'type': 0, 'taxRate': '0.00', 'address': '', 'c_address': '' }
    ],
    Vue.prototype.legalEntity = [
        {'id': 1, 'c_name': '上海嘉迅人才信息咨询有限公司', 'e_name': 'KINGFISHER EXECUTIVE SEARCH', 'type': '1', 'bank_name': '上海浦东发展银行静安支行 Shanghai Jing\’an Sub-Branch of Shanghai Pudong Development Bank', 'bank_account': '076457-98210154740005429', 'bank_address': '上海市北京西路669号 No.669 West Beijing Road, Shanghai, China', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 2, 'c_name': '泛科（上海）企业管理咨询有限公司', 'e_name': 'FACULTY RPO SOLUTIONS', 'type': '2', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 3, 'c_name': '钛锆(上海)企业管理咨询有限公司', 'e_name': 'TALENT SCOUT CONSULTING', 'type': '3', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 4, 'c_name': '伽仂(上海)技术服务有限公司', 'e_name': 'GALLOP STAFFING', 'type': '4', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 5, 'c_name': '上海赏翼商务咨询有限公司', 'e_name': 'SHOWING CONSULTING', 'type': '5', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 6, 'c_name': 'KINGFISHER RECRUITMENT(SINGAPORE)PTE.LTD.', 'e_name': 'KINGFISHER RECRUITMENT(SINGAPORE)PTE.LTD.', 'type': '1', 'bank_name': 'The Hongkong and Shanghai Banking Corporation Limited', 'bank_account': '142 009083 001', 'bank_address': '9 Battery Road #12-01 MYP Centre Singapore 049910', 'bank_code': '7232', 'disabled': false, 'swift': 'HSBCSGSG' },
        {'id': 7, 'c_name': 'KINGFISHER RECRUITMENT(MALAYSIA) SDN.BHD.', 'e_name': 'KINGFISHER RECRUITMENT(MALAYSIA) SDN.BHD.', 'type': '1', 'bank_name': 'HONG LEONG BANK', 'bank_account': '3800 0014 610', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': 'HLBBMYKL' },
        {'id': 8, 'c_name': 'KINGFISHER EXECUTIVE SEARCH (HK) LIMITED', 'e_name': 'KINGFISHER EXECUTIVE SEARCH (HK) LIMITED', 'type': '1', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 9, 'c_name': 'UKF SOLUTIONS INDIA PVT LTD', 'e_name': 'UKF SOLUTIONS INDIA PVT LTD', 'type': '1', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 10, 'c_name': '安科（上海）人力资源管理有限公司', 'e_name': 'ANCHOR RETAINER SEARCH', 'type': '1', 'bank_name': '中国工商银行股份有限公司上海市金钟支行', 'bank_account': '1001199409300074662', 'bank_address': '上海市黄浦区淮海中路 98 号金钟广场', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 11, 'c_name': '嘉迅信息咨询（北京）有限公司', 'e_name': 'KINGFISHER BEIJING', 'type': '1', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 12, 'c_name': 'Kingfisher Recruitment B.V.', 'e_name': 'Kingfisher Recruitment B.V.', 'type': '1', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },
        {'id': 13, 'c_name': '嘉迅人才管理咨詢有限公司', 'e_name': 'Kingfisher HR Solutions (Taiwan)', 'type': '1', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' },            
        {'id': 14, 'c_name': 'Kingfisher HR Solutions (Japan)', 'e_name': 'Kingfisher HR Solutions (Japan)', 'type': '1', 'bank_name': '', 'bank_account': '', 'bank_address': '', 'bank_code': '', 'disabled': false, 'swift': '' }            
    ],
    Vue.prototype.practice = [
        {'id': 2, 'e_name': 'Executive Search', 'c_name': 'Executive Search', 'sub_category': [
            {'id': 1, 'c_name': '医疗器械与生命科学', 'e_name': 'Medical Device & Life Sciences'},
            {'id': 2, 'c_name': '研发', 'e_name': 'R&D'},
            {'id': 3, 'c_name': '数字技术', 'e_name': 'Digital & Technology'},
            {'id': 4, 'c_name': '专业服务', 'e_name': 'Professional Services'},
            {'id': 5, 'c_name': '零售与奢侈品', 'e_name': 'Retail & Luxury'},
            {'id': 6, 'c_name': '法务', 'e_name': 'Legal & Compliance'},
            {'id': 7, 'c_name': '工业', 'e_name': 'Industrial & Manufacturing'},
            {'id': 8, 'c_name': '制药和生物技术', 'e_name': 'Pharmaceutical & BioTech'},
            {'id': 13, 'c_name': '人力资源', 'e_name': 'HR'},
            {'id': 16, 'c_name': '医疗器械', 'e_name': 'Medical Device'},
            {'id': 17, 'c_name': 'Business Operations', 'e_name': 'Business Operations'},
            {'id': 18, 'c_name': 'Chemical & Material Science', 'e_name': 'Chemical & Material Science'},
            {'id': 19, 'c_name': 'Research & Solutions', 'e_name': 'Research & Solutions'},
            {'id': 20, 'c_name': 'Data Science & Technoloy', 'e_name': 'Data Science & Technoloy'},
            {'id': 21, 'c_name': 'HR/Accounting & Finance', 'e_name': 'HR/Accounting & Finance'},
            {'id': 22, 'c_name': 'FMCG & Consumer Goods 1', 'e_name': 'FMCG & Consumer Goods 1'},
            {'id': 29, 'c_name': 'Financial Services', 'e_name': 'Financial Services'},
            {'id': 30, 'c_name': '半导体', 'e_name': 'Semiconductor'},
            {'id': 31, 'c_name': 'FMCG & Consumer Goods 2', 'e_name': 'FMCG & Consumer Goods 2'}
        ]},
        {'id': 3, 'e_name': 'Faculty', 'c_name': 'Faculty', 'sub_category': [
            {'id': 9, 'e_name': 'Healthcare', 'c_name': '医疗'},
            {'id': 10, 'e_name': 'Consumer', 'c_name': '消费品'},
            {'id': 11, 'e_name': 'Manufacturing', 'c_name': '制造'},
            {'id': 12, 'e_name': 'FMCG', 'c_name': '快消品'},
            {'id': 28, 'e_name': 'Pharmaceutical & Biotech', 'c_name': '制药与生物技术'},
            {'id': 32, 'e_name': 'RPO & Contracting', 'c_name': 'RPO & Contracting'}
        ]},
        {'id': 4, 'e_name': 'Gallop', 'c_name': 'Gallop', 'sub_category': [
            {'id': 23, 'e_name': 'Gallop', 'c_name': 'Gallop'}
        ]},
        {'id': 5, 'e_name': 'Talent Scout', 'c_name': 'Talent Scout', 'sub_category': [
            {'id': 24, 'e_name': 'Talent Scout', 'c_name': 'Talent Scout'}
        ]},
        {'id': 6, 'e_name': 'Showing', 'c_name': 'Showing', 'sub_category': [
            {'id': 25, 'e_name': 'Showing', 'c_name': 'Showing'}
        ]},
        {'id': 7, 'e_name': 'Anchor', 'c_name': 'Anchor', 'sub_category': [
            {'id': 26, 'e_name': 'Anchor', 'c_name': 'Anchor'}
        ]},
        {'id': 8, 'e_name': 'SeaStar', 'c_name': 'SeaStar', 'sub_category': [
            {'id': 27, 'e_name': 'SeaStar', 'c_name': 'SeaStar'}
        ]},
        {'id': 1, 'e_name': 'Recruitment Group', 'c_name': 'Recruitment Group', 'sub_category': [
            {'id': 14, 'e_name': 'Enabling', 'c_name': 'Enabling'},
            {'id': 15, 'e_name': 'BD', 'c_name': '业务开发'}
        ]}
    ],
    Vue.prototype.industry = [
        {'id': 1, 'e_name': 'Healthcare & Life Sciences', 'c_name': '医疗健康与生命科学' },
        {'id': 2, 'e_name': 'Retail & Consumer Goods', 'c_name': '零售和消费品' },
        {'id': 3, 'e_name': 'Industrial & Manufacturing', 'c_name': '工业制造' },
        {'id': 4, 'e_name': 'Professional Services', 'c_name': '专业服务' },
        {'id': 5, 'e_name': 'Digital & Technology', 'c_name': '数码科技' },
        {'id': 6, 'e_name': 'Financial Services', 'c_name': '金融服务' }
    ],
    Vue.prototype.brand = [
        {'id': 1, 'c_name': 'Recruitment Group', 'e_name': 'Recruitment Group'},
        {'id': 2, 'c_name': 'Executive Search', 'e_name': 'Executive Search'},
        {'id': 3, 'c_name': 'Faculty', 'e_name': 'Faculty'},
        {'id': 4, 'c_name': 'Gallop', 'e_name': 'Gallop'},
        {'id': 5, 'c_name': 'Talent Scout', 'e_name': 'Talent Scout'},
        {'id': 6, 'c_name': 'Showing', 'e_name': 'Showing'},
        {'id': 7, 'c_name': 'Anchor', 'e_name': 'Anchor'},
        {'id': 8, 'c_name': 'SeaStar', 'e_name': 'SeaStar'}
    ],
    Vue.prototype.invoiceType = [
	    {'id': 1, 'c_name': '增值税专用发票', 'e_name': 'VAT Special Invoice'},
	    {'id': 2, 'c_name': '增值税普通发票', 'e_name': 'VAT Invoice'},
	    {'id': 3, 'c_name': '无需发票', 'e_name': 'No Invoice'}
	],
	Vue.prototype.invoiceStatus = [
	    {'id': 0, 'c_name': '未支付', 'e_name': 'Unpaid'},
	    {'id': 1, 'c_name': '已支付', 'e_name': 'Paid'},
	    {'id': 2, 'c_name': '已冲销', 'e_name': 'Rewrote'},
	    {'id': 3, 'c_name': '已作废', 'e_name': 'Invalid'}
	],
	Vue.prototype.contractStatus = [
        {'id': 0, 'c_name': '已申请', 'e_name': 'Applied'},
        {'id': 1, 'c_name': '流程中', 'e_name': 'In Process'},
        {'id': 2, 'c_name': '已归档', 'e_name': 'Filed'},
        {'id': 3, 'c_name': '已过期', 'e_name': 'Expired'},
        {'id': 4, 'c_name': '已终止', 'e_name': 'Terminated'}
    ],
    Vue.prototype.extraRequirement = [
        {'id': 1, 'e_name': 'Business License', 'c_name': '公司营业执照' },
        {'id': 2, 'e_name': 'Account Opening License', 'c_name': '开户许可证' },
        {'id': 3, 'e_name': 'Human Resources License', 'c_name': '人力资源许可证' },
        {'id': 4, 'e_name': 'Company Seal', 'c_name': '加盖公章' },
        {'id': 5, 'e_name': 'Vendor Info Form', 'c_name': '供应商信息表' },
        {'id': 6, 'e_name': 'Multi-legal entities enabled', 'c_name': '允许多个法人实体' },
        {'id': 7, 'e_name': 'The contract is prepared by client company', 'c_name': '合同由客户公司提供' }
    ],
    Vue.prototype.applyType = [
        {'id': 1, 'e_name': 'New Client', 'c_name': '新客户' },
        {'id': 2, 'e_name': 'Renew', 'c_name': '合同更新' }
    ],
    Vue.prototype.sex = [
        {'id': 0, 'e_name': 'Male', 'c_name': '男' },
        {'id': 1, 'e_name': 'Female', 'c_name': '女' }
    ],
    Vue.prototype.userType = [
        {'id': 1, 'c_name': '总经理', 'e_name': 'GM' },
        {'id': 2, 'c_name': 'Team Leader', 'e_name': 'Team Leader' },
        {'id': 3, 'c_name': '顾问', 'e_name': 'Consultant' },
        {'id': 4, 'c_name': '寻访员', 'e_name': 'Researcher' },
        {'id': 5, 'c_name': 'HR', 'e_name': 'HR' },
        {'id': 6, 'c_name': '行政', 'e_name': 'Admin' },
        {'id': 7, 'c_name': '实习生', 'e_name': 'Intern' },
        {'id': 8, 'c_name': '财务', 'e_name': 'Finance' },
        {'id': 9, 'c_name': 'IT', 'e_name': 'IT' },
        {'id': 10, 'c_name': 'BD', 'e_name': 'BD' },
        {'id': 11, 'c_name': 'TA', 'e_name': 'TA' },
        {'id': 12, 'c_name': 'Marketing', 'e_name': 'Marketing' },
        {'id': 13, 'c_name': '派遣员工', 'e_name': 'Contractor' }
    ],
    Vue.prototype.clientStatus = [
        {'id': 0, 'e_name': 'Active', 'c_name': 'Active' },
        {'id': 1, 'e_name': 'Expired ', 'c_name': 'Expired' },
        {'id': 2, 'e_name': 'Potential ', 'c_name': 'Potential' },
        {'id': 3, 'e_name': 'Trial ', 'c_name': 'Trial' },
        {'id': 4, 'e_name': 'Inactive ', 'c_name': 'Inactive' }
    ],
    Vue.prototype.contractStatus = [
        {'id': 0, 'c_name': '已申请', 'e_name': 'Applied'},
        {'id': 1, 'c_name': '流程中', 'e_name': 'In Process'},
        {'id': 2, 'c_name': '已归档', 'e_name': 'Filed'},
        {'id': 3, 'c_name': '已过期', 'e_name': 'Expired'},
        {'id': 4, 'c_name': '已终止', 'e_name': 'Terminated'}
    ],
    Vue.prototype.offerType = [
        {'id': 0, 'e_name': 'Contingency', 'c_name': 'Contingency' },
        {'id': 1, 'e_name': 'Retained ', 'c_name': 'Retained' },
        {'id': 2, 'e_name': 'RPO', 'c_name': '招聘流程外包' },
        {'id': 3, 'e_name': 'Staffing', 'c_name': '派遣' }
    ],
    Vue.prototype.offerStatus = [
        {'id': 0, 'e_name': 'Offerred', 'c_name': '已录用' },
        {'id': 1, 'e_name': 'Onboarded', 'c_name': '已入职' },
        {'id': 4, 'e_name': 'Invoiced', 'c_name': '已开票' },
        {'id': 2, 'e_name': 'Paid', 'c_name': '已回款' },
        {'id': 3, 'e_name': 'Turned Down', 'c_name': '已拒绝' }
    ],
    Vue.prototype.turnDownType = [
        {'id': 0, 'e_name': 'Turn down offer/No show', 'c_name': '候选人拒绝Offer' },
        {'id': 1, 'e_name': 'Offer was cancelled', 'c_name': 'Offer被客户取消' },
        {'id': 2, 'e_name': 'Leave within warranty', 'c_name': '保证期内离职' },
        {'id': 3, 'e_name': 'Not pass probation', 'c_name': '未过试用期' }
    ],
    Vue.prototype.creditType = [
        {'id': 0, 'e_name': 'Sourcing', 'c_name': '寻访' },
        {'id': 1, 'e_name': 'Candidate Management', 'c_name': '候选人管理' },
        {'id': 2, 'e_name': 'Client Engagement', 'c_name': '客户管理' },
        {'id': 3, 'e_name': 'Case From', 'c_name': '职位来源' },
        {'id': 4, 'e_name': 'Contract', 'c_name': '合同' }
    ],
    Vue.prototype.cashinType = [
        {'id': 1, 'e_name': 'Revenue', 'c_name': '营业收入' },
        {'id': 2, 'e_name': 'Nonoperating Revenue', 'c_name': '非营业收入' },
        {'id': 3, 'e_name': 'Deposit', 'c_name': '预付款' },
        {'id': 4, 'e_name': 'Refund', 'c_name': '退款' }
    ],
    Vue.prototype.currencyList = [
        {'id': 1, 'e_name': 'CNY', 'c_name': 'CNY', 'cn': '人名币', 'taxRate': '0.06' },
        {'id': 2, 'e_name': 'MYR', 'c_name': 'MYR', 'cn': '林吉特', 'taxRate': '0.08' },
        {'id': 3, 'e_name': 'HKD', 'c_name': 'HKD', 'cn': '港币', 'taxRate': '0.00' },
        {'id': 4, 'e_name': 'SGD', 'c_name': 'SGD', 'cn': '新加坡元', 'taxRate': '0.09' },
        {'id': 5, 'e_name': 'USD', 'c_name': 'USD', 'cn': '美元', 'taxRate': '0.00' },
        {'id': 6, 'e_name': 'EUR', 'c_name': 'EUR', 'cn': '欧元', 'taxRate': '0.21' },
        {'id': 7, 'e_name': 'VND', 'c_name': 'VND', 'cn': '越南盾', 'taxRate': '0.00' },
        {'id': 8, 'e_name': 'KRW', 'c_name': 'KRW', 'cn': '韩国元', 'taxRate': '0.00' },
        {'id': 9, 'e_name': 'JPY', 'c_name': 'JPY', 'cn': '日元', 'taxRate': '0.1' },
        {'id': 10, 'e_name': 'INR', 'c_name': 'INR', 'cn': '印度卢比', 'taxRate': '0.00' },
        {'id': 11, 'e_name': 'NTD', 'c_name': 'NTD', 'cn': '新台币', 'taxRate': '0.05' },
        {'id': 12, 'e_name': 'PHP', 'c_name': 'PHP', 'cn': '菲律宾比索', 'taxRate': '0.00' }
    ],
    Vue.prototype.taskType = [
        {'id': 1, 'e_name': 'Offer Review', 'c_name': 'Offer审核' },
        {'id': 2, 'e_name': 'Invoice', 'c_name': '开票' },
        {'id': 3, 'e_name': 'Contract/Renew', 'c_name': '合同申请/更新' },
        {'id': 4, 'e_name': 'New Onboard', 'c_name': '新员工入职' },
        {'id': 5, 'e_name': 'Leave', 'c_name': '员工离职' },
        {'id': 6, 'e_name': 'Namecard', 'c_name': '名片申请' }
    ],
    Vue.prototype.language = [
        {'id': 1, 'e_name': 'English', 'c_name': '英文' },
        {'id': 2, 'e_name': 'Simplified Chinese', 'c_name': '简体中文' },
        {'id': 3, 'e_name': 'Tranditional Chinese', 'c_name': '繁体中文' },
        {'id': 4, 'e_name': 'Japanese', 'c_name': '日本语' }
    ],
    Vue.prototype.userRoles = [
        {'id': 1, 'e_name': 'Offer Reviwer', 'c_name': 'Offer审核' },
        {'id': 2, 'e_name': 'Invoice', 'c_name': '开票' },
        {'id': 3, 'e_name': 'Contract Reviwer', 'c_name': '合同初审' },
        {'id': 4, 'e_name': 'Contract Final Reviwer', 'c_name': '合同终审' }
    ],
    Vue.prototype.cashinType = [
        {'id': 1, 'e_name': 'Revenue', 'c_name': '营业收入' },
        {'id': 2, 'e_name': 'Nonoperating Revenue', 'c_name': '非营业收入' },
        {'id': 3, 'e_name': 'Deposit', 'c_name': '预付款' },
        {'id': 4, 'e_name': 'Refund', 'c_name': '退款' }
    ],
    Vue.prototype.invoiceStatus = [
        {'id': -1, 'c_name': '未开票', 'e_name': 'Uninvoiced'},
        {'id': 0, 'c_name': '已申请', 'e_name': 'Applied'},
        {'id': 1, 'c_name': '已开票', 'e_name': 'Invoiced'},
        {'id': 2, 'c_name': '已冲销', 'e_name': 'Rewrote'}
    ],
    Vue.prototype.contractStatus = [
        {'id': 0, 'c_name': '已申请', 'e_name': 'Applied'},
        {'id': 1, 'c_name': '流程中', 'e_name': 'In Process'},
        {'id': 2, 'c_name': '已归档', 'e_name': 'Filed'},
        {'id': 3, 'c_name': '已过期', 'e_name': 'Expired'},
        {'id': 4, 'c_name': '已终止', 'e_name': 'Inactive'}
    ],
    Vue.prototype.contractType = [
        {'id': 1, 'e_name': 'New Contract', 'c_name': '新合同' },
        {'id': 2, 'e_name': 'Contract Renew', 'c_name': '合同更新' },
        {'id': 3, 'e_name': 'Trial Contract', 'c_name': '试用合同' }
    ],
    Vue.prototype.leaveReason = [
        {'id': 100, 'c_name': '主动离职', 'e_name': 'Voluntary Leave', 'sub_category': [
            {'id': 1, 'c_name': '去其他猎头公司', 'e_name': 'Pursue a career in other search firm'},
            {'id': 2, 'c_name': '转行或转做甲方', 'e_name': 'Pursue a career in other industry or be a HR'},
            {'id': 3, 'c_name': '创业', 'e_name': 'Start own business'},
            {'id': 4, 'c_name': '念书', 'e_name': 'Further education'},
            {'id': 5, 'c_name': '实习生返校', 'e_name': 'Intern back to school'},
            {'id': 6, 'c_name': '未知原因', 'e_name': 'Unknown reason'}
        ]},
        {'id': 200, 'c_name': '被动离职', 'e_name': 'Involuntary Leave', 'sub_category': [
            {'id': 7, 'c_name': '未过试用期', 'e_name': 'Failed to pass probation'},
            {'id': 8, 'c_name': '业绩未达标', 'e_name': 'Failed to reach target'},
            {'id': 9, 'c_name': 'KPI未达标', 'e_name': 'Failed to reach KPI'},
            {'id': 10, 'c_name': '违反公司规定', 'e_name': 'Violate company regulations'},
            {'id': 11, 'c_name': '严重违反职业操守', 'e_name': 'Violate professional integrity'},
            {'id': 12, 'c_name': '组织架构调整', 'e_name': 'Team restructure'},
            {'id': 13, 'c_name': '合同到期不续签', 'e_name': 'Contract due without renewal'},
            {'id': 14, 'c_name': '其他', 'e_name': 'Others'},
        ]}
    ],
    Vue.prototype.probation = [
        {'id': 6, 'e_name': '6 months', 'c_name': '6个月' },
        {'id': 3, 'e_name': '3 months', 'c_name': '3个月' },
        {'id': 0, 'e_name': 'No probation', 'c_name': '无试用期' }
    ],
    Vue.prototype.maritalStatus = [
        {'id': 0, 'e_name': 'Unknown', 'c_name': '未知' },
        {'id': 1, 'e_name': 'Single', 'c_name': '未婚' },
        {'id': 2, 'e_name': 'Married', 'c_name': '已婚' }
    ],
    Vue.prototype.politicalStatus = [
        {'id': 0, 'e_name': 'Unknown', 'c_name': '未知' },
        {'id': 1, 'e_name': 'League Members', 'c_name': '团员' },
        {'id': 2, 'e_name': 'Party Members', 'c_name': '党员' },
        {'id': 3, 'e_name': 'Citizen', 'c_name': '群众' }
    ],
    Vue.prototype.leaveType = [
        {'id': 0, 'e_name': 'Annual Leave', 'c_name': '年假', 'disabled': false },
        {'id': 1, 'e_name': 'Sick Leave', 'c_name': '病假', 'disabled': false },
        {'id': 2, 'e_name': 'Special Leave', 'c_name': '事假', 'disabled': false },
        {'id': 3, 'e_name': 'Maternity/Breast feeding Leave', 'c_name': '产假/哺乳假', 'disabled': true },
        {'id': 4, 'e_name': 'Wedding Leave', 'c_name': '婚假', 'disabled': false },
        {'id': 5, 'e_name': 'Obstetric Inspection', 'c_name': '产检', 'disabled': false },
        {'id': 6, 'e_name': 'Parenting Leave', 'c_name': '育儿假', 'disabled': false },
        {'id': 6, 'e_name': 'Home Office', 'c_name': '居家办公', 'disabled': false }
    ],
    Vue.prototype.sourcingChannel = [
        {'id': 100, 'e_name': 'Internal Referral', 'c_name': '内部推荐' },
        {'id': 900, 'e_name': 'Internal Transfer', 'c_name': '内部转岗' },
        {'id': 200, 'e_name': 'R2R', 'c_name': 'R2R'},
        {'id': 300, 'e_name': 'TA', 'c_name': '外部推荐' },
        {'id': 350, 'e_name': 'Line Manager Hiring', 'c_name': '直线经理直招' },
        {'id': 400, 'e_name': 'Job Boards', 'c_name': '招聘网站', 'sub_category': [
            {'id': 401, 'e_name': 'Liepin', 'c_name': '猎聘'},
            {'id': 402, 'e_name': '51job', 'c_name': '前程无忧'},
            {'id': 403, 'e_name': 'Zhaopin', 'c_name': '智联招聘'},
            {'id': 404, 'e_name': 'Yingjiesheng', 'c_name': '应届生求职网'},
            {'id': 405, 'e_name': 'Shixiseng', 'c_name': '实习僧'},
            {'id': 406, 'e_name': 'Hi Shixi', 'c_name': 'Hi 实习'},
            {'id': 407, 'e_name': 'Ciweishixi', 'c_name': '刺猬实习'},
            {'id': 408, 'e_name': 'Qushixi', 'c_name': '趣实习'}
        ]},
        {'id': 500, 'e_name': 'LinkedIn', 'c_name': '领英' },
        {'id': 600, 'e_name': 'Online Applications', 'c_name': '主动申请' },
        {'id': 700, 'e_name': 'Social Networks', 'c_name': '社交网络', 'sub_category': [
            {'id': 701, 'e_name': 'Wechat', 'c_name': '微信'},
            {'id': 702, 'e_name': 'Maimai', 'c_name': '脉脉'}
        ]},
        {'id': 800, 'e_name': 'Others', 'c_name': '其他' }
    ],
    Vue.prototype.workLength = [
        {'id': 1, 'e_name': '3 months', 'c_name': '3个月之内' },
        {'id': 2, 'e_name': '3 - 6 months', 'c_name': '3到6个月之内' },
        {'id': 3, 'e_name': '6 months - 1 year', 'c_name': '6个月到1年' },
        {'id': 4, 'e_name': '1 - 2 years', 'c_name': '1年到2年' },
        {'id': 5, 'e_name': 'Above 2 years', 'c_name': '2年以上' }
    ],
    Vue.prototype.transferType = [
        {'id': 1, 'e_name': 'Transfer', 'c_name': '转款' },
        {'id': 2, 'e_name': 'Refund', 'c_name': '退款' },
        {'id': 3, 'e_name': 'Backout Unfreeze', 'c_name': '挂帐解冻' }
    ],
    Vue.prototype.onboardStatus = [
        {'id': 0, 'e_name': 'Offerred', 'c_name': '已签Offer' },
        {'id': 1, 'e_name': 'Onboarded', 'c_name': '已入职' },
        {'id': 2, 'e_name': 'Turn down/No Show', 'c_name': '拒绝/没来' }
    ],
    Vue.prototype.emailPostfix = [
        {'id': '@kingfisherchina.com', 'postfix': '@kingfisherchina.com' },
        {'id': '@facultychina.com', 'postfix': '@facultychina.com' },
        {'id': '@kingfisherintl.com', 'postfix': '@kingfisherintl.com' },
        {'id': '@facultyintl.com', 'postfix': '@facultyintl.com' },
        {'id': '@gallopstaffing.com', 'postfix': '@gallopstaffing.com' },
        {'id': '@talentscoutchina.com', 'postfix': '@talentscoutchina.com' },
        {'id': '@showingcareer.com', 'postfix': '@showingcareer.com'},
        {'id': '@anchoretained.com', 'postfix': '@anchoretained.com'}
    ],
    Vue.prototype.guaranteePeriodList = [
        {'id': 1, 'e_name': '1 month', 'c_name': '一个月' },
        {'id': 2, 'e_name': '2 months', 'c_name': '两个月' },
        {'id': 3, 'e_name': '3 months', 'c_name': '三个月' },
        {'id': 6, 'e_name': '6 months', 'c_name': '六个月' },
        {'id': 12, 'e_name': '1 year', 'c_name': '一年' },
        {'id': 0, 'e_name': 'Others', 'c_name': '其他' }
    ],
    Vue.prototype.paymentPeriodList = [
        {'id': 15, 'e_name': '15 days', 'c_name': '15天' },
        {'id': 30, 'e_name': '30 days', 'c_name': '30天' },
        {'id': 45, 'e_name': '45 days', 'c_name': '45天' },
        {'id': 60, 'e_name': '60 days', 'c_name': '60天' },
        {'id': 90, 'e_name': '90 days', 'c_name': '90天' },
        {'id': 120, 'e_name': '120 days', 'c_name': '120天' },
        {'id': 0, 'e_name': 'Others', 'c_name': '其他' }
    ],
    Vue.prototype.paymentTermList = [
        {'id': 1, 'e_name': 'One-time', 'c_name': '单笔付款' },
        {'id': 2, 'e_name': '2 installments', 'c_name': '分两期' },
        {'id': 3, 'e_name': '3 installments', 'c_name': '分三期' },
        {'id': 0, 'e_name': 'Others', 'c_name': '其他' }
    ],
    Vue.prototype.invoiceItems = [
        {'id': 1, 'e_name': '招聘费', 'c_name': '招聘费' },
        {'id': 2, 'e_name': '咨询费', 'c_name': '咨询费' }
    ],
    Vue.prototype.degree = [
        {'id': 0, 'e_name': 'Unknown', 'c_name': '未知' },
        {'id': 1, 'e_name': 'Bachelor', 'c_name': '本科' },
        {'id': 2, 'e_name': 'Master', 'c_name': '硕士' },
        {'id': 3, 'e_name': 'PhD', 'c_name': '博士' },
        {'id': 4, 'e_name': 'Diploma', 'c_name': '大专' },
        {'id': 5, 'e_name': 'Vocational School', 'c_name': '高职/中专' }
    ],
    Vue.prototype.hukouType = [
        {'id': 1, 'c_name': '城镇', 'e_name': 'Urban Household' },
        {'id': 2, 'c_name': '非城镇', 'e_name': 'Non-urban Household' }
    ],
    Vue.prototype.clientContactRole = [
        {'id': 1, 'c_name': 'HR', 'e_name': 'HR' },
        {'id': 2, 'c_name': 'Line Manager', 'e_name': 'Line Manager' },
        {'id': 3, 'c_name': 'Procurement', 'e_name': 'Procurement' },
        {'id': 4, 'c_name': 'Others', 'e_name': 'Others' }
    ],
    Vue.prototype.clientContactStatus = [
        {'id': 1, 'c_name': 'Active', 'e_name': 'Active' },
        {'id': 2, 'c_name': 'Inactive', 'e_name': 'Inactive' }
    ],
    Vue.prototype.bdBehavior = [
        {'id': 0, 'c_name': 'Phone Record', 'e_name': 'Phone Record' },
        {'id': 1, 'c_name': 'Meeting Minutes', 'e_name': 'Meeting Minutes' }
    ],
    Vue.prototype.attendeeType = [
        {'id': 0, 'c_name': 'Cross Team', 'e_name': 'Cross Team' },
        {'id': 1, 'c_name': 'Cross BU', 'e_name': 'Cross BU' },
        {'id': 2, 'c_name': 'Cross Region', 'e_name': 'Cross Region' },
        {'id': 3, 'c_name': ' Team Member', 'e_name': ' Team Member' }
    ],
    Vue.prototype.offerChannel = [
        {'id': 0, 'c_name': '猎聘', 'e_name': '猎聘' },
        {'id': 1, 'c_name': 'Boss直聘', 'e_name': 'Boss直聘' },
        {'id': 2, 'c_name': 'LinkedIn', 'e_name': 'LinkedIn' },
        {'id': 3, 'c_name': '51Job', 'e_name': '51Job' },
        {'id': 4, 'c_name': 'Mapping & Referral', 'e_name': 'Mapping & Referral' }
    ],
    Vue.prototype.paymentNotice = [
        {'id': 0, 'c_name': '中国大陆', 'e_name': 'China Mainland', 'office': [1, 2, 3, 10, 13] },
        {'id': 1, 'c_name': '新加坡', 'e_name': 'Singapore', 'office': [5] },
        {'id': 2, 'c_name': '马来西亚', 'e_name': 'Malaysia', 'office': [6] },
        {'id': 3, 'c_name': '香港', 'e_name': 'HongKong', 'office': [4] },
        {'id': 4, 'c_name': '台湾', 'e_name': 'Taiwan', 'office': [11] },
        {'id': 5, 'c_name': '荷兰', 'e_name': 'Netherlands', 'office': [7] },
        {'id': 6, 'c_name': '日本', 'e_name': 'Japan', 'office': [14] }
    ],
    Vue.prototype.invalidReason = [
        {'id': 1, 'e_name': 'Wrong mobile phone number', 'c_name': '错误的手机号' },
        {'id': 2, 'e_name': 'Invalid phone number', 'c_name': '电话无法拨打' },
        {'id': 3, 'e_name': 'No contact info', 'c_name': '无有效联系方式' }
    ],
    Vue.prototype.staffModifyType = [
        {'id': 0, 'c_name': '转团队', 'e_name': 'Team Transfer' },
        {'id': 1, 'c_name': '职位变更', 'e_name': 'Promote/Downgrade' },
        {'id': 2, 'c_name': '调薪', 'e_name': 'Salary Adjustment' },
        {'id': 3, 'c_name': '变更汇报线', 'e_name': 'Modify Report Line' },
        {'id': 4, 'c_name': 'Rejoin', 'e_name': 'Rejoin' },
        {'id': 5, 'c_name': '过试用期', 'e_name': 'Pass Probation' },
        {'id': 6, 'c_name': '实习生转正', 'e_name': 'Intern Employment' }
    ],
    Vue.prototype.meetingType = [
        {'id': 1, 'e_name': 'Client Meeting', 'c_name': '客户会议' }
    ],
    Vue.prototype.clientChannel = [
        {'id': 0, 'c_name': 'Cold Calls', 'e_name': 'Cold Calls' },
        {'id': 1, 'c_name': 'Events', 'e_name': 'Events' },
        {'id': 2, 'c_name': 'Social Media', 'e_name': 'Social Media' },
        {'id': 3, 'c_name': 'Referrals', 'e_name': 'Referrals' },
        {'id': 4, 'c_name': 'Industry Partnerships', 'e_name': 'Industry Partnerships' }
    ],
    /*Vue.prototype.getOfferChannel = function(id) {
        if (isNaN(id)) return id
        let t = this.offerChannel.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },*/
    Vue.prototype.getBDType = function(id) {
        let t = this.bdBehavior.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getAttendeeType = function(id) {
        let t = this.attendeeType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getBdBehavior = function(id) {
        let t = this.bdBehavior.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getClientContactRole = function(id) {
        let t = this.clientContactRole.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getUserType = function(id) {
        if (id == null || id == undefined) return ''
        let t = this.userType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getOffice = function(id) {
        if (id == null || id == undefined) return ''
        let t = this.office.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getOfficeObj = function(id) {
        if (id == null || id == undefined) return ''
        let t = this.office.find(function(obj) {
            return obj.id === id
        })
        return t
    },
    Vue.prototype.getGuaranteePeriod = function(id) {
        let t = this.guaranteePeriodList.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getPaymentPeriod = function(id) {
        let t = this.paymentPeriodList.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getPaymentTerm = function(id) {
        let t = this.paymentTermList.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getClientStatus = function(id) {
        let t = this.clientStatus.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getContractStatus = function(id) {
        let t = this.contractStatus.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getContractType = function(id) {
        let t = this.contractType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getPractice = function(id) {
        if (id == null || id == undefined)
            return ''
        let brand = ''
        let t = this.practice.find(function(obj) {
            return obj.id === id[0]
        })
        brand = this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
        let subCategory = t['sub_category']
        let sc = subCategory.find(function(obj) {
            return obj.id === id[1]
        })
        //console.log(id)
        if (sc == null || sc == undefined) return ''
        return (this.$i18n.locale === 'zh' ? sc['c_name'] : sc['e_name'])
    },
    Vue.prototype.getPractice1 = function(id) {
        if (id == null || id == undefined)
            return ''
        let sc = null,
            p = null
        for (p in this.practice) {
            //console.log(p)
            let subCategory = this.practice[p]['sub_category']
            sc = subCategory.find(function(obj) {
                return obj.id === id
            })
            //console.log(id)
            if (sc != null && sc != undefined) break
        }
        
        if (sc == null || sc == undefined) return ''
        return (this.$i18n.locale === 'zh' ? sc['c_name'] : sc['e_name'])
    },
    Vue.prototype.getBrand = function(id) {
        if (id == 0 || id == null || id == undefined)
            return ''
        let t = this.brand.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getIndustry = function(id) {
        if (id == 0 || id == null || id == undefined)
            return ''
        let t = this.industry.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getTurnDownType = function(id) {
        let t = this.turnDownType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getInvoiceType = function(id) {
        let i = this.invoiceType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? i['c_name'] : i['e_name']
    },
    Vue.prototype.getInvoiceStatus = function(id) {
        let t = this.invoiceStatus.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getOfferStatus = function(id) {
        let t = this.offerStatus.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getLegalEntity = function(id) {
        let le = this.legalEntity.find(function(obj) {
            return obj.id === id
        })
        if (le)
          return this.$i18n.locale === 'zh' ? le['c_name'] : le['e_name']
        return null
    },
    Vue.prototype.getLegalEntityObj = function(id) {
        let le = this.legalEntity.find(function(obj) {
            return obj.id === id
        })
        return le
    },
    Vue.prototype.getCurrency = function(id) {
        if (id == 0 || id == null || id == undefined)
            return this.currencyList[0]
        let t = this.currencyList.find(function(obj) {
            return obj.id === id
        })
        return t
    },
    Vue.prototype.getCurrencyInfo = function(id) {
        let t = null
        if (id == 0 || id == null || id == undefined)
            t = this.currencyList[0]
        else 
            t = this.currencyList.find(function(obj) {
              return obj.id === id
            })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getCashinType = function(id) {
        let t = this.cashinType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getTaskType = function(id) {
        let t = this.taskType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getOfferType = function(id) {
        let t = this.offerType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getCreditType = function(id) {
        let t = this.creditType.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    }
  }
}